import { render, staticRenderFns } from "./LeisureGameLinksComp.vue?vue&type=template&id=71133963&scoped=true&"
import script from "./LeisureGameLinksComp.vue?vue&type=script&lang=js&"
export * from "./LeisureGameLinksComp.vue?vue&type=script&lang=js&"
import style0 from "./LeisureGameLinksComp.vue?vue&type=style&index=0&id=71133963&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71133963",
  null
  
)

export default component.exports